import { render, staticRenderFns } from "./approve-emolument-location.vue?vue&type=template&id=2d756041"
import script from "./approve-emolument-location.vue?vue&type=script&lang=js"
export * from "./approve-emolument-location.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports